"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Configuration_1 = require("@becrop/components/Results/TrialsResults/Abstract/Models/Configuration");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const ConfigurationSchemeLine_vue_1 = __importDefault(require("./ConfigurationSchemeLine.vue"));
const SamplePill_vue_1 = __importDefault(require("./SamplePill.vue"));
const ModalSamples_vue_1 = __importDefault(require("./ModalSamples.vue"));
const trans_1 = require("@common/tsutils/trans");
let ConfigurationScheme = class ConfigurationScheme extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.deployedLines = [0, 1];
        this.toSearch = '';
        this.isModalDeployed = false;
        this.configurationOptions = new Configuration_1.ConfigurationOptions({
            'location': 'All Locations',
            'treatment': 'All Products',
            'time': 'All Times',
            'configurationRows': this.configuration.configurationRows
        });
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    dismissModal() {
        this.isModalDeployed = false;
    }
    deployModal() {
        this.isModalDeployed = true;
    }
    get plainSamples() {
        let mySamples = [];
        for (let location of this.configuration.locations) {
            for (let treatment of location.treatments) {
                for (let time of treatment.times) {
                    mySamples = [...mySamples, ...time.samples];
                }
            }
        }
        return mySamples;
    }
    get filteredSamples() {
        return this.plainSamples;
    }
    toggleLine(i) {
        if (this.deployedLines.includes(i)) {
            this.deployedLines = this.deployedLines.filter((element) => element !== i);
        }
        else {
            this.deployedLines.push(i);
        }
    }
    viewList(locIx, treatIx, timeIx) {
        this.configurationOptions = new Configuration_1.ConfigurationOptions({
            'location': (locIx === -1) ? (0, trans_1.trans)('trialsSummaryPublic.cards.all_locs') : this.configuration.locations[locIx].name,
            'treatment': (treatIx === -1) ? (0, trans_1.trans)('trialsSummaryPublic.cards.all_prods') : this.configuration.locations[locIx].treatments[treatIx].name,
            'time': (timeIx === -1) ? (0, trans_1.trans)('trialsSummaryPublic.cards.all_times') : (timeIx === 0) ? ' T0' : 'T' + this.configuration.locations[locIx].treatments[treatIx].times[timeIx].time,
            'configurationRows': this.configuration.rowifyCustomConfiguration(locIx, treatIx, timeIx)
        });
        this.deployModal();
    }
    onchangesearch(textSearch) {
        this.toSearch = textSearch;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ConfigurationScheme.prototype, "configuration", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ConfigurationScheme.prototype, "theme", void 0);
ConfigurationScheme = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ConfigurationSchemeLine: ConfigurationSchemeLine_vue_1.default,
            SamplePill: SamplePill_vue_1.default,
            ModalSamples: ModalSamples_vue_1.default,
            Search: bmk_ui_framework_1.Search,
            Link: bmk_ui_framework_1.Link
        },
    })
], ConfigurationScheme);
exports.default = ConfigurationScheme;
